import calculateSignedForms from "./store-modules/signedForms";
import cardsMoulde from "./store-modules/cards";
import dataContextModule from "./store-modules/dataContext";
import enums from "./Enums";
import fields from "../utils/fields";
import flowsModule from "./store-modules/flows";
import mdiIcons from "../utils/mdi-icons.json";
import referenceItemsModule from "./store-modules/referenceItems";
import registrationModule from "./store-modules/registration";
import signPackageModule from "./store-modules/signPackage";
import siteContentMoulde from "./store-modules/siteContent";

export default {
  install(Vue) {
    const registration = registrationModule(Vue);
    const signPackage = signPackageModule(Vue);
    const flows = flowsModule(Vue);
    const dataContext = dataContextModule(Vue);
    const siteContent = siteContentMoulde(Vue);
    let cards = cardsMoulde(Vue);
    let referenceItems = referenceItemsModule(Vue);

    let state = {
      current: {
        //messages
        messageThreads: [],
        unreadMessageThreads: []
      },
      clients: [],
      clientsById: {},
      clientsLoaded: false,
      clientsLoadedViews: [],
      files: [],
      filesById: {},

      //TODO: remove this
      addedvalueServer: "https://app.addedvalue.co.il",
      calendlyLink: "https://calendly.com/addedvalue/30min",

      clientSearch: "",
      clientSearchActiveOnly: false,
      // clientWithActionsSearch: "",
      mislakaSearch: "",

      //used for nav controls in adminlayout
      context: {},
      //{ routename: MenuItems[] }
      customMenuItems: {},

      forms: [],
      formsByCategory: [],
      formsRules: [],
      maslulim: {},
      maslulimDate: {},
      bituachMaslulim: {},

      savedItems: [],
      filters: {},
      hanmakaLines: [],
      openDialogs: [],
      longActionModalRef: null,
      lastSignature: {},
      signatureTimeToLive: 24 * 60 * 60 * 1000, //one day

      enums: enums,
      fields: fields,
      mdiIcons: mdiIcons,
      registration: registration,
      signPackage: signPackage,
      flows: flows,
      cards: cards,
      dataContext: dataContext,
      siteContent: siteContent,
      referenceItems: referenceItems,
    };

    Vue.prototype.$store = new Vue({
      data() {
        return state;
      },
      computed: {
        filtersAsItems() {
          let filtersByGroups = {};
          for (let filter in this.filters) {
            let filterDetails = this.filters[filter];
            let group = filterDetails.group || "כללי";
            if (!(group in filtersByGroups)) {
              filtersByGroups[group] = [];
            }
            filtersByGroups[group].push(filter);
          }
          let items = [];
          for (let group in filtersByGroups) {
            let filters = filtersByGroups[group];
            items.push({ header: group }, { divider: true }, ...filters);
          }
          return items;
        }
      },
      methods: {
        resetState() {
          //messages
          this.current.messageThreads = [];
          this.current.unreadMessageThreads = [];
        },
        calculateSignedForms(reports) {
          return calculateSignedForms(reports);
        },
        async reloadUnreadMessageThreads() {
          this.current.unreadMessageThreads =
            await this.$actions.messages.loadUnread();
        },
        async reloadAllMessageThreads() {
          this.current.messageThreads = await this.$actions.messages.load();
        },
        openCalendlyPopup() {
          let values = {
            name: `${this.$account.info.shem_prati} ${this.$account.info.shem_mishpacha}`,
            email: this.$account.info.email,
            location: "+972" + this.$account.info.cellular
          };
          let query = Object.entries(values)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join("&");

          let url = this.$store.calendlyLink;
          if (query) {
            url += "?" + query;
          }

          window.Calendly.initPopupWidget({ url });
        },
        /**
         * Get client info by ID synchronously from cache only (does not load if missing).
         * Use this in computed properties and other synchronous contexts.
         * @param {string} clientId - Client ID to fetch
         * @returns {Object|undefined} Client info object or undefined if not in cache
         */
        getClientInfoIfLoaded(clientId) {
          if (this.clientsById[clientId] && this.clientsById[clientId].info) {
            return this.clientsById[clientId].info;
          }
          return undefined;
        },
        /**
         * Ensure clients cache is loaded for a given view.
         * If view is empty, ensures full clients list is loaded once.
         * If view is provided and not loaded yet, it reloads with all requested views.
         * @param {string|undefined|null} view - Optional view to ensure in cache
         * @returns {Promise<Object[]>} Loaded clients list
         */
        async ensureClientsLoadedWithView(view) {
          const normalizedView =
            typeof view === "string" ? view.trim() : undefined;

          if (!normalizedView) {
            if (!this.clientsLoaded) {
              await this.$actions.clients.loadClients();
            }
            return this.clients;
          }

          const loadedViews = this.clientsLoadedViews || [];
          if (loadedViews.includes(normalizedView)) {
            return this.clients;
          }

          const requestedViews = [...new Set([...loadedViews, normalizedView])];
          await this.$actions.clients.loadClients({ views: requestedViews });
          return this.clients;
        },
        /**
         * Get client info by ID. Checks cache first, then calls loadClients() if needed.
         * Use this in async methods.
         * @param {string} clientId - Client ID to fetch
         * @returns {Promise<Object|undefined>} Client info object or undefined if not found
         */
        async getClientInfo(clientId) {
          if (!clientId) {
            return undefined;
          }

          await this.ensureClientsLoadedWithView();

          return this.getClientInfoIfLoaded(clientId);
        },
        setLongActionModalRef(ref) {
          this.longActionModalRef = ref;
        },
        trackLongAction(title, promiseOrFactory, options) {
          this.longActionModalRef?.run(title, promiseOrFactory, options);
        }
      }
    });

    Vue.prototype.$store.$account.$on("logout", () =>
      Vue.prototype.$store.resetState()
    );

    window.$store = Vue.prototype.$store;
  }
};
